<div class="tw:w-full tw:px-[15px] tw:mx-auto" style="min-height: calc(100vh - 480px);">
  <div class="tw:flex tw:flex-wrap tw:-mx-[15px]">

    <ng-template #utilityBarForm>

      <!-- tw:px-3 = 12px, matching the main content card's side margins (tw:mx-3);
           rows below carry no extra horizontal insets of their own. -->
      <div class="tw:pt-4 tw:pb-4 tw:px-3">

        <!-- Switch on, one responsive .filter-bar serves every width and the mobile variant is not rendered. -->
        <div [class.desktop-grid]="!filtersEnabled" [class.filter-bar]="filtersEnabled">

          @if (enhancedSearchPermission) {
            <div class="tw:flex tw:flex-wrap filter-bar__group">
              <div class="tw:flex-1 tw:flex tw:flex-col tw:p-0 filter-bar__field" style="flex: 2;">
                <label class="field__label">{{ filtersEnabled ? 'Client' : '--- Select Client ---' }}</label>
                <app-searchable-select class="tw:w-full" [(ngModel)]="selectedClient" [items]="clientList"
                  displayField="clientName" [disabledPredicate]="clientDisabled"
                  placeholder="--- Select Client ---" searchPlaceholder="Search clients…"></app-searchable-select>
                @if (showClientAccessError) {
                  <div class="tw:text-danger">
                    No Valid Client Roles Assigned.
                  </div>
                }
                @if (showClientValidationError) {
                  <div class="tw:text-danger">
                    Please select a client.
                  </div>
                }
              </div>
                <div class="tw:flex-1 tw:flex tw:justify-center tw:items-end tw:pb-2 tw:px-2 filter-bar__field filter-bar__field--check">
                  <label class="field__toggle"><input type="checkbox" [(ngModel)]="showEnded" /><span class="field__toggle-track"></span><span class="overview-filter-label">Show Ended</span></label>
                  </div>
                  @if (!filtersEnabled) {
                    <div class="tw:flex tw:p-0 tw:w-full tw:lg:w-1/5" style="align-items: flex-end;">
                      <button type="button" class="btn btn-primary tw:w-full"
                        style="height: 38px;"
                      (click)="searchPlacements()" [disabled]="fromDateAfterToDate">Search</button>
                    </div>
                  }
                </div>
              }

              <div class="tw:flex tw:flex-wrap tw:gap-4 filter-bar__group" *appFeatureSwitch="featureKeys.filtersSessionOverview" id="overviewFilters">
                <app-brand-filter class="filter-bar__field" [companyIds]="companyIds" (companyIdsChange)="brandsChanged($event)"></app-brand-filter>
                <div class="tw:flex tw:flex-col filter-bar__field">
                  <label class="overview-filter-label filter-bar__label" for="overviewDeliveryFilter">Delivery</label>
                  <select id="overviewDeliveryFilter" class="field__control" [(ngModel)]="clientFilters.deliveryMode" [ngModelOptions]="{standalone: true}">
                    <option [ngValue]="null">All</option>
                    @for (option of deliveryModeOptions; track option.value) {
                      <option [ngValue]="option.value">{{option.label}}</option>
                    }
                  </select>
                </div>
                <div class="tw:flex tw:flex-col filter-bar__field">
                  <label class="overview-filter-label filter-bar__label" for="overviewOrderTypeFilter">Order type</label>
                  <select id="overviewOrderTypeFilter" class="field__control" [(ngModel)]="clientFilters.provisionType" [ngModelOptions]="{standalone: true}">
                    <option [ngValue]="null">All</option>
                    @for (option of orderTypeOptions; track option.value) {
                      <option [ngValue]="option.value">{{option.label}}</option>
                    }
                  </select>
                </div>
              </div>

              @if (!filtersEnabled) {
              <!-- Tailwind-only classes here: the global (unlayered) .flex-row sets display:flex, which
                   beats the layered tw:hidden/tw:lg:hidden utilities and made both variants render. -->
              <div class="tw:hidden tw:lg:flex tw:flex-row tw:flex-wrap tw:w-full tw:justify-between">

                <!-- inline padding: the unlayered .flex-column padding beats layered tw:p-0/tw:pr-0 -->
                <div class="flex-column tw:p-0" style="padding: 0;">

                  <div class="flex-row tw:h-full tw:justify-center tw:items-end">

                    <div class="flex-column">
                      <button class="btn btn-outline-primary"
                        [ngClass]="{'active': selectedFilterDateRange == 'today'}" type="button"
                      (click)="filterDateRangeChange('today')">Today</button>
                    </div>

                    <div class="flex-column">
                      <button class="btn btn-outline-primary"
                        [ngClass]="{'active': selectedFilterDateRange == 'tomorrow'}" type="button"
                      (click)="filterDateRangeChange('tomorrow')">Tomorrow</button>
                    </div>

                    @if (!filtersEnabled) {
                    <div class="flex-column">
                      <button class="btn btn-outline-primary"
                        [ngClass]="{'active': selectedFilterDateRange == 'lastWeek'}" type="button"
                      (click)="filterDateRangeChange('lastWeek')">Last Week</button>
                    </div>
                    }

                    @if (!filtersEnabled) {
                    <div class="flex-column">
                      <button class="btn btn-outline-primary"
                        [ngClass]="{'active': selectedFilterDateRange == 'thisWeek'}" type="button"
                      (click)="filterDateRangeChange('thisWeek')">This Week</button>
                    </div>
                    }
                    @if (filtersEnabled) {
                      <div class="flex-column">
                        <app-date-presets [selected]="datePreset" (presetSelected)="onDatePreset($event)"></app-date-presets>
                      </div>
                    }

                    <div class="flex-column tw:pr-0" style="padding-right: 0;">
                      <button class="btn btn-outline-primary"
                        [ngClass]="{'active': selectedFilterDateRange == 'custom'}" type="button"
                      (click)="filterDateRangeChange('custom')">Custom</button>
                    </div>

                  </div>

                  @if (selectedFilterDateRange == 'custom') {
                    <div class="flex-row">
                      <div class="flex-column">
                        <label class="overview-filter-label">From Date</label>
                        <input type="date" class="field__control" [(ngModel)]="fromDate" [ngModelOptions]="{standalone: true}" (change)="validateDates()" (input)="datePreset = null">
                          @if (fromDateAfterToDate) {
                            <span class="field__error">From date cannot be after To date</span>
                          }
                        </div>
                        <div class="flex-column tw:pr-0" style="padding-right: 0;">
                          <label class="overview-filter-label">To Date</label>
                          <input type="date" class="field__control" [(ngModel)]="toDate" [ngModelOptions]="{standalone: true}" (change)="validateDates()" (input)="datePreset = null">
                          </div>
                        </div>
                      }

                    </div>

                  </div>

                  <div class="tw:flex tw:lg:hidden tw:flex-row tw:flex-wrap tw:w-full tw:justify-between">

                    <div class="flex-column">
                      <button class="btn btn-outline-primary"
                        [ngClass]="{'active': selectedFilterDateRange == 'today'}" type="button"
                      (click)="filterDateRangeChange('today')">Today</button>
                    </div>

                    <div class="flex-column">
                      <button class="btn btn-outline-primary"
                        [ngClass]="{'active': selectedFilterDateRange == 'tomorrow'}" type="button"
                      (click)="filterDateRangeChange('tomorrow')">Tomorrow</button>
                    </div>

                    @if (!filtersEnabled) {
                    <div class="flex-column">
                      <button class="btn btn-outline-primary"
                        [ngClass]="{'active': selectedFilterDateRange == 'lastWeek'}" type="button"
                      (click)="filterDateRangeChange('lastWeek')">Last Week</button>
                    </div>
                    }

                    @if (!filtersEnabled) {
                    <div class="flex-column tw:pr-0">
                      <button class="btn btn-outline-primary"
                        [ngClass]="{'active': selectedFilterDateRange == 'thisWeek'}" type="button"
                      (click)="filterDateRangeChange('thisWeek')">This Week</button>
                    </div>
                    }
                    @if (filtersEnabled) {
                      <div class="flex-column">
                        <app-date-presets [selected]="datePreset" (presetSelected)="onDatePreset($event)"></app-date-presets>
                      </div>
                    }

                  </div>

                  <div class="tw:flex tw:lg:hidden tw:flex-row tw:flex-wrap tw:w-full tw:justify-between">

                    <div class="flex-column tw:self-end tw:mb-1 tw:pb-4">
                      <button class="btn btn-outline-primary"
                        [ngClass]="{'active': selectedFilterDateRange == 'custom'}" type="button"
                      (click)="filterDateRangeChange('custom')">Custom</button>
                    </div>

                    @if (selectedFilterDateRange == 'custom') {
                      <div class="flex-column">
                        <label class="overview-filter-label">From Date</label>
                        <input type="date" class="field__control" [(ngModel)]="fromDate" [ngModelOptions]="{standalone: true}" (change)="validateDates()" (input)="datePreset = null">
                          @if (fromDateAfterToDate) {
                            <span class="field__error">From date cannot be after To date</span>
                          }
                        </div>
                      }

                      @if (selectedFilterDateRange == 'custom') {
                        <div class="flex-column tw:pr-0" style="padding-right: 0;">
                          <label class="overview-filter-label">To Date</label>
                          <input type="date" class="field__control" [(ngModel)]="toDate" [ngModelOptions]="{standalone: true}" (change)="validateDates()" (input)="datePreset = null">
                          </div>
                        }

                      </div>

                      @if (!enhancedSearchPermission && selectedFilterDateRange == 'custom') {
                        <div class="flex-row tw:flex">
                          <div class="flex-column tw:p-0">
                            <button type="submit" class="btn btn-primary" (click)="searchPlacements()"
                            [disabled]="fromDateAfterToDate">Search</button>
                          </div>
                        </div>
                      }
              } @else {
                @if (selectedFilterDateRange == 'custom') {
                  <div class="filter-bar__field">
                    <label class="field__label">From Date</label>
                    <input type="date" class="field__control" [(ngModel)]="fromDate" [ngModelOptions]="{standalone: true}" (change)="validateDates()" (input)="datePreset = null">
                    @if (fromDateAfterToDate) {
                      <span class="field__error">From date cannot be after To date</span>
                    }
                  </div>
                  <div class="filter-bar__field">
                    <label class="field__label">To Date</label>
                    <input type="date" class="field__control" [(ngModel)]="toDate" [ngModelOptions]="{standalone: true}" (change)="validateDates()" (input)="datePreset = null">
                  </div>
                }
                <div class="filter-bar__actions">
                  <div class="filter-bar__presets" role="group" aria-label="Date range">
                    <button class="btn btn-outline-primary btn-sm" [ngClass]="{'active': selectedFilterDateRange == 'today'}" type="button"
                      (click)="filterDateRangeChange('today')">Today</button>
                    <button class="btn btn-outline-primary btn-sm" [ngClass]="{'active': selectedFilterDateRange == 'tomorrow'}" type="button"
                      (click)="filterDateRangeChange('tomorrow')">Tomorrow</button>
                    <app-date-presets [selected]="datePreset" (presetSelected)="onDatePreset($event)"></app-date-presets>
                    <button class="btn btn-outline-primary btn-sm" [ngClass]="{'active': selectedFilterDateRange == 'custom'}" type="button"
                      (click)="filterDateRangeChange('custom')">Custom</button>
                  </div>
                  <div class="filter-bar__buttons">
                    <app-filter-clear-all (clear)="clearAll()"></app-filter-clear-all>
                    <!-- The range buttons search straight away; without the enhanced search permission, Search is only for a custom range, as before. -->
                    @if (enhancedSearchPermission || selectedFilterDateRange == 'custom') {
                      <button type="button" class="btn btn-primary" (click)="searchPlacements()" [disabled]="fromDateAfterToDate">Search</button>
                    }
                  </div>
                </div>
              }

                    </div>

                    @if (!filtersEnabled) {
                    <div class="mobile-grid">
                      <div class="mobile-grid">

                        @if (enhancedSearchPermission) {
                          <div class="flex-row tw:my-4">
                            <div class="flex-column">
                              <label>Client</label>
                              <app-searchable-select [(ngModel)]="selectedClient" [items]="clientList"
                                displayField="clientName" placeholder="--- Select Client ---"
                                searchPlaceholder="Search clients…"></app-searchable-select>
                            </div>
                          </div>
                        }

                        <ng-container *appFeatureSwitch="featureKeys.filtersSessionOverview">
                          <div class="flex-row tw:my-4">
                            <div class="flex-column">
                              <app-brand-filter [companyIds]="companyIds" (companyIdsChange)="brandsChanged($event)"></app-brand-filter>
                            </div>
                          </div>
                          <div class="flex-row tw:my-4">
                            <div class="flex-column">
                              <label>Delivery</label>
                              <select class="field__control" [(ngModel)]="clientFilters.deliveryMode" [ngModelOptions]="{standalone: true}">
                                <option [ngValue]="null">All</option>
                                @for (option of deliveryModeOptions; track option.value) {
                                  <option [ngValue]="option.value">{{option.label}}</option>
                                }
                              </select>
                            </div>
                          </div>
                          <div class="flex-row tw:my-4">
                            <div class="flex-column">
                              <label>Order type</label>
                              <select class="field__control" [(ngModel)]="clientFilters.provisionType" [ngModelOptions]="{standalone: true}">
                                <option [ngValue]="null">All</option>
                                @for (option of orderTypeOptions; track option.value) {
                                  <option [ngValue]="option.value">{{option.label}}</option>
                                }
                              </select>
                            </div>
                          </div>
                        </ng-container>

                        <div class="flex-row">

                          <div class="flex-column">
                            <button class="btn btn-outline-primary"
                              [ngClass]="{'active': selectedFilterDateRange == 'today'}" type="button"
                            (click)="filterDateRangeChange('today')">Today</button>
                          </div>

                          <div class="flex-column">
                            <button class="btn btn-outline-primary"
                              [ngClass]="{'active': selectedFilterDateRange == 'tomorrow'}" type="button"
                            (click)="filterDateRangeChange('tomorrow')">Tomorrow</button>
                          </div>
                        </div>

                        <div class="flex-row">
                          @if (!filtersEnabled) {
                          <div class="flex-column">
                            <button class="btn btn-outline-primary"
                              [ngClass]="{'active': selectedFilterDateRange == 'lastWeek'}" type="button"
                            (click)="filterDateRangeChange('lastWeek')">Last Week</button>
                          </div>
                          }

                          @if (!filtersEnabled) {
                          <div class="flex-column">
                            <button class="btn btn-outline-primary"
                              [ngClass]="{'active': selectedFilterDateRange == 'thisWeek'}" type="button"
                            (click)="filterDateRangeChange('thisWeek')">This Week</button>
                          </div>
                          }
                          @if (filtersEnabled) {
                            <div class="flex-column">
                              <app-date-presets [selected]="datePreset" (presetSelected)="onDatePreset($event)"></app-date-presets>
                            </div>
                          }
                        </div>

                        <div class="flex-row">
                          <div class="flex-column">
                            <button class="btn btn-outline-primary"
                              [ngClass]="{'active': selectedFilterDateRange == 'custom'}" type="button"
                            (click)="filterDateRangeChange('custom')">Custom</button>
                          </div>
                        </div>

                        @if (selectedFilterDateRange == 'custom') {
                          <div class="flex-row tw:my-4">
                            <div class="flex-column">
                              <label>From Date</label>
                              <input type="date" class="field__control" [(ngModel)]="fromDate" [ngModelOptions]="{standalone: true}" (change)="validateDates()" (input)="datePreset = null">
                                @if (fromDateAfterToDate) {
                                  <span class="field__error">From date cannot be after To date</span>
                                }
                              </div>
                            </div>
                          }

                          @if (selectedFilterDateRange == 'custom') {
                            <div class="flex-row tw:my-4">
                              <div class="flex-column">
                                <label>To Date</label>
                                <input type="date" class="field__control" [(ngModel)]="toDate" [ngModelOptions]="{standalone: true}" (change)="validateDates()" (input)="datePreset = null">
                                </div>
                              </div>
                            }

                            @if (enhancedSearchPermission) {
                              <div class="flex-row tw:mt-2 tw:p-2 tw:md:mt-6 tw:md:pt-6">
                                <div class="flex-column tw:pt-2">
                                  <label class="field__toggle"><input type="checkbox" [(ngModel)]="showEnded" /><span class="field__toggle-track"></span> Show Ended</label>
                                </div>
                              </div>
                            }

                            <div class="flex-row tw:my-6 tw:pt-4 tw:px-2">
                              <div class="flex-column">
                                <button type="submit" class="btn-outline-primary btn tw:mx-1 tw:w-full" (click)="searchPlacements()"
                                style="height: 35px;">Search</button>
                                <app-filter-clear-all *appFeatureSwitch="featureKeys.filtersSessionOverview" (clear)="clearAll()"></app-filter-clear-all>
                              </div>
                            </div>

                          </div>
                        </div>
                    }

                      </div>

                    </ng-template>

                    @if (initialSearchCompleted) {
                      <div class="tw:w-full tw:p-0 tw:m-0 tw:h-full">
                        <div class="tw:flex tw:flex-wrap tw:px-0 tw:mx-0 tw:my-2 tw:pt-2 tw:sm:pt-0 tw:pb-4">
                          <div class="tw:w-full tw:m-0 tw:py-2">
                            <session-overview-placement-main (toggleFullscreen)="togglePlacementFullscreen($event)"></session-overview-placement-main>
                          </div>
                        </div>
                      </div>
                    }

                    </div>
                  </div>
